module.exports = __webpack_public_path__ + "img/ludwig_px.4d49fdc5.png";